// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class DeploymentSettings  {
    _originalTypeClassName = "LoomTenantManagement.BO.DeploymentSettings";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
DeploymentSettings.translate = translateService;
}
this.ModuleDeployments = [];
this.Id = null;
this.ServerIP = null;
this.PortainerStackId = null;
this.PortainerStackName = null;
this.PortainerEndpointId = null;
this.PortainerUrl = null;
this.OneSignalKey = null;
this.SentryUrl = null;
this.LoomBOPortHttp = null;
this.LoomFEPortHttp = null;
this.LoomBOImageTag = null;
this.LoomFEImageTag = null;
this.AzureLoginClientId = null;
this.AzureTenantIDs = null;
this.JwtKey = null;
this.JwtKeyId = null;
this.MariaDBPort = null;
this.ClickUpKey = null;
this.ClickUpTeamId = null;
this.ClickUpIssuesListId = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
ServerIP:any;
PortainerStackId:any;
PortainerStackName:any;
PortainerEndpointId:any;
PortainerUrl:any;
OneSignalKey:any;
SentryUrl:any;
LoomBOPortHttp:any;
LoomFEPortHttp:any;
LoomBOImageTag:any;
LoomFEImageTag:any;
AzureLoginClientId:any;
AzureTenantIDs:any;
JwtKey:any;
JwtKeyId:any;
MariaDBPort:any;
ClickUpKey:any;
ClickUpTeamId:any;
ClickUpIssuesListId:any;
Tenant:any;
ModuleDeployments:any;
static setTenant = ($this, value) => {
var oldValue = $this.Tenant;
$this.Tenant = value;
if (value != null) {
if (oldValue != null && oldValue.Deployment != null) { oldValue.Deployment = null; }
if ($this.Tenant.Deployment !== $this) {
Domain.Tenant.setDeployment(value, $this);
}
}
}
static setModuleDeployments = ($this, items) => {
                if (items == null) items = [];
                if ($this.ModuleDeployments == null) $this.ModuleDeployments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ModuleDeployments.length > 0) {
                    Domain.DeploymentSettings.removeModuleDeployments($this, $this.ModuleDeployments[0]);
                }

                Domain.DeploymentSettings.addManyModuleDeployments($this, copyItems);
            }
static addManyModuleDeployments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.DeploymentSettings.addModuleDeployments($this, items[i]);
                }
            }
static addModuleDeployments = ($this, item) => {
                if ($this.ModuleDeployments == null) $this.ModuleDeployments = [];
                if (item == null || $this.ModuleDeployments.indexOf(item) > -1) return;
                $this.ModuleDeployments.push(item);
if (item.Deployment != $this) {
Domain.ModuleDeployment.setDeployment(item, $this);
}
}
static addRangeModuleDeployments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.DeploymentSettings.addModuleDeployments($this, item));
            }
static removeModuleDeployments = ($this, item) => {
                if ($this == null || $this.ModuleDeployments == null || $this.ModuleDeployments.indexOf(item) === -1) return;
                var _index = $this.ModuleDeployments.indexOf(item);
                $this.ModuleDeployments.splice(_index, 1);
item.Deployment = null;
}
static clearModuleDeployments = ($this) => { $this.ModuleDeployments = null; }

static GetPortainerUrl($this: any): any{let url_template = "https://loom.konnecta.io:9443/#!/{0}/docker/stacks/{1}?id={2}&type=2&regular=true&orphaned=false&orphanedRunning=false";
return CLMS.Framework.String.Format(url_template, $this?.PortainerEndpointId, $this?.PortainerStackName, $this?.PortainerStackId);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}